module.exports = __webpack_public_path__ + "img/macOs-dl-formatted.9cc0ac6a.png";